const environment = window.location.host.includes('ego-now.com') ? 'production' : 'staging'

export default {
  environment: environment,
  apiBaseUrl:
    environment === 'production'
      ? 'https://api.ego-now.com/api/v0'
      : 'https://api.procabnow.com/api/v0',
  baseUrl:
    environment === 'production'
      ? 'https://dashboard.ego-now.com'
      : 'https://dashboard.procabnow.com',
  release: 'b39d22ff16bdc185043bfd2444244f4a9be35807'
}
